import { render, staticRenderFns } from "./RegistroVejezAnticipada.vue?vue&type=template&id=1b5e9043&scoped=true"
import script from "./RegistroVejezAnticipada.vue?vue&type=script&lang=ts"
export * from "./RegistroVejezAnticipada.vue?vue&type=script&lang=ts"
import style0 from "./RegistroVejezAnticipada.vue?vue&type=style&index=0&id=1b5e9043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5e9043",
  null
  
)

export default component.exports